import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  chartConfusionMatrix: {
    width: '100%',
    height: 'auto',
    fontFamily: 'inherit',
    color: t.baseTextColor,
  },

  xAxisText: {
    textAnchor: 'end',
    transform: 'rotate(-45deg)',
  },

  yAxisLabel: {
    transform: 'rotate(-90deg)',
    textAnchor: 'middle',
    fill: 'currentColor',
    fontSize: '.7rem',
    textTransform: 'uppercase',
    fontWeight: 600,
  },

  yAxisText: {
    textAnchor: 'end',
    transform: 'rotate(-45deg)',
  },

  xAxisLabel: {
    textAnchor: 'middle',
    fill: 'currentColor',
    fontSize: '.7rem',
    textTransform: 'uppercase',
    fontWeight: 600,
  },

  rectText: {
    alignmentBaseline: 'central',
    textAnchor: 'middle',
    fontSize: '.7rem',
  },

  rectShadow: {
    stroke: '#bc31a2',
    strokeWidth: '0.15rem',
    strokeOpacity: '0.5',
  },

  rectUnshadow: {
    stroke: 'unset',
  },

  chartHeader: {
    textAnchor: 'middle',
    fill: 'currentColor',
    fontSize: '.7rem',
    color: t.primary,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    textAlign: 'center',
    margin: '1.7rem 0 1rem 1.3rem',
  },
}))

export default useStyles
